var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4620_32961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 2.5625C3.15394 2.5625 0 5.717 0 9.59375C0 13.4705 3.15422 16.625 7.03125 16.625C10.9086 16.625 14.0625 13.4705 14.0625 9.59375C14.0625 5.717 10.9083 2.5625 7.03125 2.5625ZM7.03125 15.219C3.92934 15.219 1.40597 12.6957 1.40597 9.59375C1.40597 6.49241 3.92906 3.96903 7.03125 3.96903C10.1329 3.96903 12.656 6.49241 12.656 9.59375C12.6557 12.6957 10.1326 15.219 7.03125 15.219Z",
    fill: "#545B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.13216 7.43853C5.39263 7.1624 5.70395 6.93913 6.04903 6.78097C6.40127 6.61915 6.78472 6.53658 7.17234 6.53909C7.66425 6.53909 8.11566 6.65637 8.52713 6.89094C8.93274 7.12032 9.27833 7.44241 9.53569 7.83088L10.5381 7.08134C10.1572 6.56143 9.66245 6.13561 9.09159 5.83653C8.51166 5.52884 7.87153 5.375 7.17206 5.375C6.59578 5.375 6.05409 5.48637 5.54728 5.70969C5.05188 5.92393 4.60198 6.23083 4.22175 6.61391C3.84207 6.99927 3.53896 7.45317 3.3285 7.95153C3.10941 8.46172 3 9.00987 3 9.59403C3 10.1776 3.10941 10.7252 3.3285 11.2368C3.53874 11.735 3.84188 12.1885 4.22175 12.5733C4.602 12.9566 5.05189 13.2639 5.54728 13.4787C6.05437 13.7008 6.59606 13.8125 7.17206 13.8125C7.87153 13.8125 8.51137 13.6587 9.09159 13.3507C9.66276 13.0521 10.1577 12.6262 10.5381 12.1059L9.53569 11.3575C9.27791 11.7454 8.93239 12.0671 8.52713 12.2966C8.11566 12.5308 7.66425 12.6481 7.17234 12.6481C6.78471 12.6508 6.40122 12.5682 6.04903 12.4062C5.70389 12.2482 5.39256 12.0249 5.13216 11.7487C4.87116 11.4731 4.66359 11.1493 4.50975 10.7809C4.35591 10.4125 4.27913 10.0162 4.27913 9.59403C4.27913 9.17103 4.35591 8.77531 4.50975 8.40659C4.66359 8.03787 4.87116 7.71528 5.13216 7.43853Z",
    fill: "#545B5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4620_32961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyright);
export default __webpack_public_path__ + "static/media/copyright.10b25b25f3473016d821c48488ebb5fd.svg";
export { ForwardRef as ReactComponent };